import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { fadeUp, viewport, stagger } from "@/lib/motion";
import { Target, ShieldCheck, LineChart, Sparkles } from "lucide-react";

const REASONS = [
  {
    icon: Target,
    title: "Single-organ focus",
    body: "We don't do everything for everyone. We do liver precision medicine, exceptionally well.",
  },
  {
    icon: ShieldCheck,
    title: "Physician-led, always",
    body: "Every score, plan and protocol is owned by a hepatology-trained doctor — never an algorithm alone.",
  },
  {
    icon: LineChart,
    title: "Measured, not guessed",
    body: "Objective biomarkers and imaging at every stage. We show you the numbers moving.",
  },
  {
    icon: Sparkles,
    title: "Designed for real life",
    body: "Protocols engineered around Indian diets, routines and realities — so they actually stick.",
  },
];

export const WhySuperAge = () => {
  return (
    <section id="why-superage" className="bg-sa-bg py-16 md:py-20" data-testid="why-superage-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="max-w-3xl">
          <p className="mb-4 text-[13px] font-semibold uppercase tracking-[0.2em] text-sa-copper">
            Why SuperAge
          </p>
          <h2 className="font-display text-4xl font-medium leading-[1.08] tracking-tight text-sa-forest sm:text-5xl">
            Not a hospital. A precision liver health company.
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2"
        >
          {REASONS.map((r) => {
            const Icon = r.icon;
            return (
              <motion.div
                key={r.title}
                variants={fadeUp}
                className="flex gap-5 rounded-[28px] border border-sa-beige bg-white p-8 transition-transform duration-300 hover:-translate-y-1"
              >
                <span className="flex h-12 w-12 flex-none items-center justify-center rounded-2xl bg-sa-forest text-sa-copper">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-display text-xl font-medium text-sa-forest">
                    {r.title}
                  </h3>
                  <p className="mt-2 leading-relaxed text-sa-muted">{r.body}</p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default WhySuperAge;
